import React, { useState } from 'react'
import Login from '../components/Login/Login.js'

const LoginPage = ({ onLogin }) => {
  return <Login onLogin={onLogin}></Login>
}

export default LoginPage
